module.exports = __webpack_public_path__ + "img/9788949123042.a355a4e2.jpg";